import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PaymentSipFormComponent } from './payment-sip-form.component';
import { ReactiveFormsModule } from '@angular/forms';
import { InputModule } from '../input/input.module';
// import { IntlInputModule } from '../intl-input/intl-input.module';
import { PaymentSipButtonModule } from '../payment-sip-button/payment-sip-button.module';
import { PaymentSipDonorsModule } from '../payment-sip-donors/payment-sip-donors.module';
import { PaymentSipSlabsModule } from '../payment-sip-slabs/payment-sip-slabs.module';
import { ModuleLoaderModule } from '../module-loader/module-loader.module';
import { GCaptchaModule } from '../g-captcha/g-captcha.module';
import { OfferTagModule } from '../offer-tag/offer-tag.module';
import { PledgeFrequencySlabModule } from '../pledge-frequency-slab/pledge-frequency-slab.module';
import { MultiCauseSipSelectionModule } from '../multi-cause-sip-selection/multi-cause-sip-selection.module';
import { PhoneNumberInputV2Component } from 'src/app/core/phone-number-input-v2/phone-number-input-v2.component';

@NgModule({
  declarations: [PaymentSipFormComponent],
  exports: [PaymentSipFormComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    InputModule,
    // IntlInputModule,
    PaymentSipButtonModule,
    PaymentSipDonorsModule,
    PaymentSipSlabsModule,
    ModuleLoaderModule,
    GCaptchaModule,
    OfferTagModule,
    PledgeFrequencySlabModule,
    MultiCauseSipSelectionModule,
    PhoneNumberInputV2Component
  ]
})
export class PaymentSipFormModule { }
